import { useCallback, useRef, useEffect } from 'react';
import { useStores } from '../../../stores/setup/use-store';

export const useLocationSearch = () => {
	const {
		dataStores: { locationStore },
	} = useStores();

	const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		return () => {
			if (debounceTimeoutRef.current) {
				clearTimeout(debounceTimeoutRef.current);
			}
		};
	}, []);

	const handleSearchChange = useCallback((searchTerm: string) => {
		locationStore.setSearchTerm(searchTerm);

		if (debounceTimeoutRef.current) {
			clearTimeout(debounceTimeoutRef.current);
		}

		debounceTimeoutRef.current = setTimeout(() => {
			locationStore.setCurrentPage(0);
			locationStore.getLocationsAPI();
		}, 500);
	}, [locationStore]);

	return {
		searchTerm: locationStore.searchTerm,
		setSearchTerm: handleSearchChange,
		filteredLocations: locationStore.locations,
	};
};